export default __webpack_public_path__ + "static/media/gsap.dff87e2d.svg";